/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
const DefaultError = () => {

    return (
        <div className="main-content">
            <div>
                <div className="field field-field.component">
                    <div className="component rich-text" id="field-component-43888204-81c5-425c-8063-e6451ee17ed3">
                        <div className="rich-text-container ">
                            <p>You have searched for a page that is
                            not&nbsp;available on our&nbsp;website.
                            </p>
                            <p>You can try another search, or:&nbsp;</p>
                            <ul>
                                <li><p><a href={"/"}>Go to the homepage</a></p></li>
                                <li><p><a href={"/"}>Contact us</a></p></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { DefaultError };
